import React from 'react';

import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

import { IconButton, Popover } from '@mui/material';

import Tooltip from 'ui/Tooltip';

import {
  WhyControlWrapper,
  WhyPopoverBody,
  WhyPopoverText,
} from 'containers/PipelinesDetails/components/conditions/styles';

export interface WhyShown {
  triggerName: string;
  explanation: string;
}

export interface FieldNote {
  fieldKey: string;
  /** Set when the field is shown and adjacency could not explain why. */
  why?: WhyShown;
  /** Set under Show all fields on a configured field whose condition does not currently match. */
  notAsked?: boolean;
}

export const FieldNotesContext = React.createContext<Record<string, FieldNote>>({});

export const WhyShownControl: React.FunctionComponent<{
  why: WhyShown;
  fieldName: string;
  fieldKey: string;
}> = ({ why, fieldName, fieldKey }) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const label = 'Why is this field shown?';

  return (
    <WhyControlWrapper>
      <Tooltip title={label}>
        <IconButton
          size="small"
          data-testid={`why-shown-${fieldKey}`}
          aria-label={label}
          aria-haspopup="dialog"
          aria-expanded={Boolean(anchorEl)}
          onClick={(event) => setAnchorEl(anchorEl ? null : event.currentTarget)}
        >
          <InfoOutlinedIcon fontSize="small" color="action" />
        </IconButton>
      </Tooltip>
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        data-surface-role="transient"
      >
        <WhyPopoverBody role="dialog" aria-label={`${fieldName}: ${label}`}>
          <WhyPopoverText>{why.explanation}</WhyPopoverText>
        </WhyPopoverBody>
      </Popover>
    </WhyControlWrapper>
  );
};
